import {Api, Method} from "../../api/api";
import {ActionUrl, REMOVE_TAG_CLASS_NAME, TAG_CLASS_NAME, TaskType} from "../constants";
import {showToast} from "../../toast";
import {tagsEventEmitter} from "../event-emitter";

/**
 * Удаление метки. В конструктор передаётся элемент метки и затем происходит её удаление после запроса.
 */
class RemoveTag {
  private element: HTMLElement;
  private id: number;
  private taskId: number;
  private type: string | undefined;

  private api: Api = new Api();
  private url: string;
  private emitter = tagsEventEmitter;

  constructor() {
    this.onDocumentClick = this.onDocumentClick.bind(this);

    document.addEventListener(`click`, this.onDocumentClick);
  }

  /**
   * Инициализация
   */
  private init(): void {
    this.type = this.element.dataset.type;

    if (this.type === TaskType.ADD && this.element.dataset.taskId) {
      this.url = ActionUrl.REMOVE_TAG_FROM_TASK_URL;
      this.taskId = +this.element.dataset.taskId;
    } else {
      this.url = ActionUrl.REMOVE_TAG_URL;
    }

    if (this.element.dataset.id) {
      this.id = +this.element.dataset.id;

      void this.removeTag();
    }
  }

  /**
   * Удаление метки
   */
  private async removeTag(): Promise<void> {
    if (this.type === TaskType.CREATE) {
      this.element.remove();
      this.emitter.emit(`removeTaskTag`, this.id);
    } else {
      const {code, answer} = await this.api.customQuery(this.url, {
        method: Method.POST,
        query:
          this.type === TaskType.ADD
            ? JSON.stringify({
                id: this.id,
                taskId: this.taskId,
              })
            : JSON.stringify({
                id: this.id,
              }),
      });

      if (code === 200) {
        this.element.remove();
      } else {
        showToast(answer.text);
      }
    }
  }

  onDocumentClick(evt) {
    const target = evt.target;

    if (target.classList.contains(REMOVE_TAG_CLASS_NAME)) {
      evt.stopPropagation();

      this.element = target.closest(`.${TAG_CLASS_NAME}`);

      this.init();
    }
  }
}

export {RemoveTag};
